import actions from "./actions";

const initState = {
    createTransactionsState: null,
    createTransactionsResult: null,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.IMPORT_CREATE_TRANSACTIONS_REQUEST:
            return {
                ...state,
                createTransactionsState: 'request',
            };
        case actions.IMPORT_CREATE_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                createTransactionsState: 'success',
                createTransactionsResult: action.data,
            };
        case actions.IMPORT_RESET_STATE:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
